import { IconProps } from './IconProps';

export function CloseIcon(props: IconProps) {
    return (
        <svg
            width="24"
            height="24"
            {...props}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 11.25L6.75 6L6 6.75L11.25 12L6.00006 17.25L6.75006 18L12 12.75L17.25 18L18 17.25L12.75 12L18 6.75003L17.25 6.00004L12 11.25Z"
                fill="#66182A"
            />
        </svg>
    );
}
